import React, { useState } from 'react';
import ResponsesTable from './ResponsesTable';

const TagSection = ({ stat, responses }) => {
  const [isExpanded, setIsExpanded] = useState(false);

  const yesCount = parseInt(stat.yes_count) || 0;
  const noCount = parseInt(stat.no_count) || 0;
  const totalResponses = parseInt(stat.total_responses) || 0;
  const totalRespondents = parseInt(stat.total_respondents) || 0;
  const openedCount = parseInt(stat.opened_count) || 0;
  const totalSent = parseInt(stat.total_sent) || 0;
  const openRate = totalSent > 0 ? ((openedCount / totalSent) * 100).toFixed(1) : 0;

  return (
    <div className="bg-white rounded-lg shadow mb-4 overflow-hidden">
      <div 
        className={`p-6 cursor-pointer hover:bg-gray-50 transition ${
          isExpanded ? 'bg-gray-50' : ''
        }`}
        onClick={() => setIsExpanded(!isExpanded)}
      >
        <div className="flex items-center justify-between">
          <div className="flex-1">
            <h2 className="text-xl font-bold text-gray-900 mb-3">{stat.tag}</h2>
            <div className="flex flex-wrap gap-4">
              <span className="text-sm text-gray-600">📧 {totalSent} Sent</span>
              <span className="text-sm text-gray-600">📬 {openedCount} Opened ({openRate}%)</span>
              <span className="text-sm text-gray-600">👥 {totalRespondents} Respondents</span>
              <span className="text-sm text-green-600 font-semibold">✅ {yesCount} Yes</span>
              <span className="text-sm text-red-600 font-semibold">❌ {noCount} No</span>
              <span className="text-sm text-gray-600">📊 {totalResponses} Total</span>
            </div>
          </div>
          <span className="text-gray-400 text-2xl ml-4">
            {isExpanded ? '▲' : '▼'}
          </span>
        </div>
      </div>
      {isExpanded && (
        <div className="border-t border-gray-200 p-6">
          <ResponsesTable responses={responses} />
        </div>
      )}
    </div>
  );
};

export default TagSection;
